import React        from 'react';
import ModalContext from '@widesk-ui/contexts/ModalContext';

export default function useModal() {
	return React.useContext(ModalContext);
}
